export default "__VITE_PUBLIC_ASSET__e097b603__"